import { render } from "./cra_dashboard.vue?vue&type=template&id=394c630e&scoped=true"
import script from "./cra_dashboard.js?vue&type=script&lang=js"
export * from "./cra_dashboard.js?vue&type=script&lang=js"

import "./cra_dashboard.vue?vue&type=style&index=0&id=394c630e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394c630e"]])

export default __exports__